import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { AssessmentQuestion } from "./types";

interface OwnerReadinessCompletionScreenProps {
  question: AssessmentQuestion;
  onFinish: () => void;
  scoreIncrease?: number;
}

export function OwnerReadinessCompletionScreen({ 
  question, 
  onFinish, 
  scoreIncrease = 12 
}: OwnerReadinessCompletionScreenProps) {
  const navigate = useNavigate();

  return (
    <div className="text-center space-y-8 py-8 w-full max-w-4xl mx-auto min-h-[400px] flex flex-col justify-center">
      <div className="space-y-4">
        <h2 className="text-2xl font-semibold text-foreground">
          Personal Readiness Assessment Complete
        </h2>
        <p className="text-lg text-muted-foreground max-w-lg mx-auto">
          You've taken an important step in understanding your personal readiness for succession.
        </p>
        <p className="text-lg text-muted-foreground max-w-lg mx-auto">
          Your mySuccession score has <span className="text-primary font-semibold">increased by {scoreIncrease}%</span>. 
          This reflects your commitment to thoughtful succession planning and provides insights into areas for development.
        </p>
      </div>
      
      <div className="flex gap-4 justify-center">
        <Button 
          size="sm" 
          onClick={onFinish} 
          variant="outline"
          className="px-4 py-2 h-auto text-sm"
        >
          Close Assessment
        </Button>
        <Button 
          size="sm" 
          onClick={() => navigate("/dashboard")}
          className="bg-accent hover:bg-accent/90 text-accent-foreground px-4 py-2 h-auto text-sm"
        >
          View Dashboard
        </Button>
      </div>
    </div>
  );
}